import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.options = {
      variant: 'flex.column',
      width: '100%',
    };
  })()
);
